const crossSellingButton = document.getElementById("crossSellingButton");
if (crossSellingButton) {
  crossSellingButton.addEventListener("click", function (event) {
    event.preventDefault();

    const crossSellingElement = document.getElementById("crossSellingData");
    const metafields = JSON.parse(
      crossSellingElement.getAttribute("data-metafields")
    );
    const items = [];

    metafields.forEach((product, index) => {
      const selectElement = document.getElementById(
        `cs-product-options-${index + 1}`
      );

      const variantId =
        product.variants.length > 1 && selectElement
          ? selectElement.value || product.variants[0].id
          : product.variants[0].id;

      const productCompare =
        product.compare_at_price >= product.price
          ? product.compare_at_price
          : 0;

      const discountPercentCart = getDiscountPercentage(
        product.compare_at_price,
        product.price
      );

      const productTagDiscount =
        product.compare_at_price >= product.price
          ? Math.floor(discountPercentCart)
          : 0;

      items.push({
        id: variantId,
        quantity: 1,
        properties: {
          productType: "delivery",
          productCompare: productCompare,
          productTagDiscount: productTagDiscount,
        },
      });
    });

    crossAddToCart(items);
  });
}

const crossSellingButtonMobile = document.getElementById(
  "crossSellingButtonMobile"
);
if (crossSellingButtonMobile) {
  crossSellingButtonMobile.addEventListener("click", function (event) {
    event.preventDefault();

    const crossSellingElement = document.getElementById("crossSellingData");
    const metafields = JSON.parse(
      crossSellingElement.getAttribute("data-metafields")
    );
    const items = [];

    metafields.forEach((product, index) => {
      const selectElement = document.getElementById(
        `cs-product-options-${index + 1}`
      );

      const variantId =
        product.variants.length > 1 && selectElement
          ? selectElement.value || product.variants[0].id
          : product.variants[0].id;

      const productCompare =
        product.compare_at_price >= product.price
          ? product.compare_at_price
          : 0;

      const discountPercentCart = getDiscountPercentage(
        product.compare_at_price,
        product.price
      );

      const productTagDiscount =
        product.compare_at_price >= product.price
          ? Math.floor(discountPercentCart)
          : 0;

      items.push({
        id: variantId,
        quantity: 1,
        properties: {
          productType: "delivery",
          productCompare: productCompare,
          productTagDiscount: productTagDiscount,
        },
      });
    });

    crossAddToCart(items);
  });
}
